module.exports = __webpack_public_path__ + "static/media/bg_like_fail.96104ed8.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/portfolio/assets/bg_like_fail.png
// module id = 2232
// module chunks = 2